export function createCoach({ client, speaker, toggle, onText = () => {}, onError = () => {},
  minIntervalMs = 12000, now = () => Date.now(), online = () => globalThis.navigator?.onLine !== false } = {}) {
  let busy = false;
  let last = 0;

  const enabled = () => Boolean(client?.available && toggle?.enabled);

  return {
    get configured() {
      return Boolean(client?.available);
    },
    get enabled() {
      return enabled();
    },
    get busy() {
      return busy;
    },
    due() {
      return enabled() && !busy && online() && now() - last >= minIntervalMs;
    },
    reset() {
      last = 0;
    },
    async observe({ phase = "photo", result = null, imageDataUrl = null, force = false } = {}) {
      if (!enabled() || busy || !online()) return null;
      if (!force && now() - last < minIntervalMs) return null;
      busy = true;
      last = now();
      try {
        const text = await client.advise({ phase, result, imageDataUrl });
        if (!text) return null;
        onText(text);
        await speaker?.speak(text);
        return text;
      } catch (error) {
        onError(error);
        return null;
      } finally {
        busy = false;
      }
    }
  };
}
